import { action, createRequestTypes } from '../base';

export const forecastActionTypes = {
  CREATE_FORECAST: createRequestTypes('CREATE_FORECAST'),
  START_FORECAST: createRequestTypes('START_FORECAST'),
  GET_FORECAST_LIST: createRequestTypes('GET_FORECAST_LIST'),
  GET_FORECAST_BY_ID: createRequestTypes('GET_FORECAST_BY_ID'),
  GET_FORECAST_RESULTS: createRequestTypes('GET_FORECAST_RESULTS'),
  DOWNLOAD_FORECAST: createRequestTypes('DOWNLOAD_FORECAST'),
};

/**
 * ForecastActions class
 */
class ForecastActions {
    /**
     *
     * @param formData
     * @param callback
     * @returns {*}
     */
    createForecast = (formData, callback) => action(forecastActionTypes.CREATE_FORECAST.REQUEST, {
      formData, callback,
    });

    /**
     *
     * @param createForecastLoading
     * @returns {*}
     */
    createForecastLoading = (createForecastLoading) => action(forecastActionTypes.CREATE_FORECAST.LOADING, {
      createForecastLoading,
    });

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    startForecast = (payload, callback) => action(forecastActionTypes.START_FORECAST.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param startForecastLoading
     * @returns {{type: *}}
     */
    startForecastLoading = (startForecastLoading) => action(forecastActionTypes.START_FORECAST.LOADING, {
      startForecastLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {*}
     */
    getForecastList = (payload, callback) => action(forecastActionTypes.GET_FORECAST_LIST.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param getForecastListLoading
     * @returns {*}
     */
    getForecastListLoading = (getForecastListLoading) => action(forecastActionTypes.GET_FORECAST_LIST.LOADING, {
      getForecastListLoading,
    })

    /**
     *
     * @param forecasts
     * @returns {*}
     */
    getForecastListSuccess = (forecasts) => action(forecastActionTypes.GET_FORECAST_LIST.SUCCESS, {
      forecasts,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {*}
     */
    getForecastById = (payload, callback) => action(forecastActionTypes.GET_FORECAST_BY_ID.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param getForecastByIdLoading
     * @returns {*}
     */
    getForecastByIdLoading = (getForecastByIdLoading) => action(forecastActionTypes.GET_FORECAST_BY_ID.LOADING, {
      getForecastByIdLoading,
    })

    /**
     *
     * @param selectedForecast
     * @returns {*}
     */
    getForecastByIdSuccess = (selectedForecast) => action(forecastActionTypes.GET_FORECAST_BY_ID.SUCCESS, {
      selectedForecast,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    getForecastResults = (payload, callback) => action(forecastActionTypes.GET_FORECAST_RESULTS.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param getForecastResultsLoading
     * @returns {{type: *}}
     */
    getForecastResultsLoading = (getForecastResultsLoading) => action(forecastActionTypes.GET_FORECAST_RESULTS.LOADING, {
      getForecastResultsLoading,
    })

    /**
     *
     * @param forecastResults
     * @returns {{type: *}}
     */
    getForecastResultsSuccess = (forecastResults) => action(forecastActionTypes.GET_FORECAST_RESULTS.SUCCESS, {
      forecastResults,
    })

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    downloadForecast = (payload, callback) => action(forecastActionTypes.DOWNLOAD_FORECAST.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param downloadForecastLoading
     * @returns {{type: *}}
     */
    downloadForecastLoading = (downloadForecastLoading) => action(forecastActionTypes.DOWNLOAD_FORECAST.LOADING, {
      downloadForecastLoading,
    })
}

export default new ForecastActions();
